<template>
  <BaseToggleButton
    :key="resetKey"
    v-bind="$attrs"
    :checked="checked"
    :label="label"
    :help="help"
    :checked-label="checkedLabel"
    :unchecked-label="uncheckedLabel"
    :disabled="effectiveDisabled"
    @change="handleChange"
  />
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";

import BaseToggleButton from "@/components/base/BaseToggleButton.vue";
import * as inject from "@/components/inject";
import { openUpgradeModal } from "@/components/modals/upgrade";

export default defineComponent({
  components: {
    BaseToggleButton,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    help: {
      type: String,
      default: null,
    },
    checkedLabel: {
      type: String,
      default: "",
    },
    uncheckedLabel: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    entitlementKey: {
      type: String,
      required: true,
    },
    organizationId: {
      type: String,
      default: undefined,
    },
  },
  emits: {
    change: (_: boolean) => true,
  },
  setup(props, { emit }) {
    const billing = inject.billing();
    const resetKey = ref(0);

    const isEntitledTo = computed(() => {
      return (
        billing.value?.isEntitledTo(props.entitlementKey, props.organizationId)
          ?.value ?? false
      );
    });

    const effectiveDisabled = computed(() => {
      return props.disabled;
    });

    const handleChange = (checked: boolean) => {
      // Only enabling is gated: the user must always be able to turn a
      // feature off, even after the entitlement was lost while it was on.
      if (checked && !isEntitledTo.value) {
        openUpgradeModal(billing, props.organizationId, props.entitlementKey);
        resetKey.value++;
        return;
      }

      emit("change", checked);
    };

    return {
      effectiveDisabled,
      handleChange,
      resetKey,
    };
  },
});
</script>
